import { render } from "./random.vue?vue&type=template&id=42050ce2"
import script from "./random.vue?vue&type=script&lang=js"
export * from "./random.vue?vue&type=script&lang=js"

import "./random.vue?vue&type=style&index=0&id=42050ce2&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__